module.exports = __webpack_public_path__ + "web_static/img/innovate_animation.0e162cb3.gif";